import { lazy } from 'react';

// Helper to define registry entries
const def = (label, importFn) => ({ label, loader: importFn });

export const iconRegistry = {
  // --- Health & Body ---
  'weight': def('Weight', () => import('@mui/icons-material/MonitorWeight')),
  'sleep': def('Sleep', () => import('@mui/icons-material/Bedtime')),
  'heart': def('Heart', () => import('@mui/icons-material/Favorite')),
  'heartrate': def('Heart Rate', () => import('@mui/icons-material/MonitorHeart')),
  'blood': def('Blood', () => import('@mui/icons-material/Bloodtype')),
  'temperature': def('Temperature', () => import('@mui/icons-material/Thermostat')),
  'healing': def('Healing', () => import('@mui/icons-material/Healing')),
  'sick': def('Sick', () => import('@mui/icons-material/Sick')),
  'masks': def('Masks', () => import('@mui/icons-material/Masks')),

  // --- Medical ---
  'medication': def('Medication', () => import('@mui/icons-material/Medication')),
  'hospital': def('Hospital', () => import('@mui/icons-material/LocalHospital')),
  'pharmacy': def('Pharmacy', () => import('@mui/icons-material/LocalPharmacy')),
  'vaccine': def('Vaccine', () => import('@mui/icons-material/Vaccines')),

  // --- Fitness & Exercise ---
  'dumbbell': def('Dumbbell', () => import('@mui/icons-material/FitnessCenter')),
  'running': def('Running', () => import('@mui/icons-material/DirectionsRun')),
  'walking': def('Walking', () => import('@mui/icons-material/DirectionsWalk')),
  'cycling': def('Cycling', () => import('@mui/icons-material/DirectionsBike')),
  'swimming': def('Swimming', () => import('@mui/icons-material/Pool')),
  'hiking': def('Hiking', () => import('@mui/icons-material/Hiking')),
  'stairs': def('Stairs', () => import('@mui/icons-material/Stairs')),
  'workout': def('Workout', () => import('@mui/icons-material/SportsGymnastics')),
  'accessibility': def('Body', () => import('@mui/icons-material/AccessibilityNew')),

  // --- Sports ---
  'sports': def('Sports', () => import('@mui/icons-material/Sports')),
  'basketball': def('Basketball', () => import('@mui/icons-material/SportsBasketball')),
  'soccer': def('Soccer', () => import('@mui/icons-material/SportsSoccer')),
  'tennis': def('Tennis', () => import('@mui/icons-material/SportsTennis')),
  'volleyball': def('Volleyball', () => import('@mui/icons-material/SportsVolleyball')),

  // --- Food & Drink ---
  'food': def('Food', () => import('@mui/icons-material/Restaurant')),
  'nutrition': def('Nutrition', () => import('@mui/icons-material/Restaurant')),
  'menu': def('Menu', () => import('@mui/icons-material/RestaurantMenu')),
  'fastfood': def('Fast Food', () => import('@mui/icons-material/Fastfood')),
  'lunch': def('Lunch', () => import('@mui/icons-material/LunchDining')),
  'egg': def('Egg', () => import('@mui/icons-material/Egg')),
  'icecream': def('Ice Cream', () => import('@mui/icons-material/Icecream')),
  'water': def('Water', () => import('@mui/icons-material/LocalDrink')),
  'waterdrop': def('Water Drop', () => import('@mui/icons-material/WaterDrop')),
  'coffee': def('Coffee', () => import('@mui/icons-material/Coffee')),
  'cafe': def('Cafe', () => import('@mui/icons-material/LocalCafe')),
  'alcohol': def('Alcohol', () => import('@mui/icons-material/Liquor')),
  'beer': def('Beer', () => import('@mui/icons-material/SportsBar')),
  'kitchen': def('Kitchen', () => import('@mui/icons-material/Kitchen')),

  // --- Mental & Mood ---
  'mood': def('Mood', () => import('@mui/icons-material/Mood')),
  'brain': def('Brain', () => import('@mui/icons-material/Psychology')),
  'meditation': def('Meditation', () => import('@mui/icons-material/SelfImprovement')),
  'spa': def('Spa', () => import('@mui/icons-material/Spa')),
  'happy': def('Happy', () => import('@mui/icons-material/EmojiEmotions')),
  'satisfied': def('Satisfied', () => import('@mui/icons-material/SentimentSatisfied')),
  'neutral': def('Neutral', () => import('@mui/icons-material/SentimentNeutral')),
  'dissatisfied': def('Dissatisfied', () => import('@mui/icons-material/SentimentDissatisfied')),
  'veryhappy': def('Very Happy', () => import('@mui/icons-material/SentimentVerySatisfied')),
  'verysad': def('Very Sad', () => import('@mui/icons-material/SentimentVeryDissatisfied')),
  'face': def('Face', () => import('@mui/icons-material/Face')),

  // --- Habits ---
  'smoking': def('Smoking', () => import('@mui/icons-material/SmokingRooms')),
  'gaming': def('Gaming', () => import('@mui/icons-material/SportsEsports')),
  'reading': def('Reading', () => import('@mui/icons-material/MenuBook')),
  'headphones': def('Headphones', () => import('@mui/icons-material/Headphones')),
  'music': def('Music', () => import('@mui/icons-material/MusicNote')),
  'phone': def('Phone', () => import('@mui/icons-material/Phone')),
  'smartphone': def('Smartphone', () => import('@mui/icons-material/Smartphone')),
  'speaking': def('Speaking', () => import('@mui/icons-material/RecordVoiceOver')),
  'mic': def('Microphone', () => import('@mui/icons-material/Mic')),

  // --- Time & Productivity ---
  'timer': def('Timer', () => import('@mui/icons-material/Timer')),
  'alarm': def('Alarm', () => import('@mui/icons-material/Alarm')),
  'calendar': def('Calendar', () => import('@mui/icons-material/CalendarToday')),
  'event': def('Event', () => import('@mui/icons-material/Event')),
  'today': def('Today', () => import('@mui/icons-material/Today')),
  'task': def('Task', () => import('@mui/icons-material/TaskAlt')),
  'checkcircle': def('Check', () => import('@mui/icons-material/CheckCircle')),
  'work': def('Work', () => import('@mui/icons-material/Work')),
  'school': def('School', () => import('@mui/icons-material/School')),

  // --- Nature & Weather ---
  'sun': def('Sun', () => import('@mui/icons-material/WbSunny')),
  'lightmode': def('Day', () => import('@mui/icons-material/LightMode')),
  'moon': def('Moon', () => import('@mui/icons-material/NightsStay')),
  'darkmode': def('Night', () => import('@mui/icons-material/DarkMode')),
  'cloud': def('Cloud', () => import('@mui/icons-material/Cloud')),
  'breathing': def('Air', () => import('@mui/icons-material/Air')),
  'forest': def('Forest', () => import('@mui/icons-material/Forest')),
  'park': def('Park', () => import('@mui/icons-material/Park')),
  'grass': def('Grass', () => import('@mui/icons-material/Grass')),
  'flower': def('Flower', () => import('@mui/icons-material/LocalFlorist')),
  'vintage': def('Vintage', () => import('@mui/icons-material/FilterVintage')),
  'yard': def('Yard', () => import('@mui/icons-material/Yard')),
  'waves': def('Waves', () => import('@mui/icons-material/Waves')),
  'nature': def('Nature', () => import('@mui/icons-material/NaturePeople')),

  // --- Measurement ---
  'measure': def('Measure', () => import('@mui/icons-material/Straighten')),
  'speed': def('Speed', () => import('@mui/icons-material/Speed')),
  'insights': def('Insights', () => import('@mui/icons-material/Insights')),
  'chart': def('Chart', () => import('@mui/icons-material/ShowChart')),
  'trendingup': def('Trending Up', () => import('@mui/icons-material/TrendingUp')),
  'trendingdown': def('Trending Down', () => import('@mui/icons-material/TrendingDown')),
  'opacity': def('Opacity', () => import('@mui/icons-material/Opacity')),

  // --- Achievement & Goals ---
  'star': def('Star', () => import('@mui/icons-material/Star')),
  'trophy': def('Trophy', () => import('@mui/icons-material/EmojiEvents')),
  'medal': def('Medal', () => import('@mui/icons-material/MilitaryTech')),
  'flag': def('Flag', () => import('@mui/icons-material/Flag')),
  'rocket': def('Rocket', () => import('@mui/icons-material/RocketLaunch')),
  'thumbup': def('Thumb Up', () => import('@mui/icons-material/ThumbUp')),
  'thumbdown': def('Thumb Down', () => import('@mui/icons-material/ThumbDown')),

  // --- Energy & Power ---
  'energy': def('Energy', () => import('@mui/icons-material/Bolt')),
  'flash': def('Flash', () => import('@mui/icons-material/FlashOn')),

  // --- Social & People ---
  'person': def('Person', () => import('@mui/icons-material/Person')),
  'people': def('People', () => import('@mui/icons-material/People')),
  'group': def('Group', () => import('@mui/icons-material/Diversity3')),
  'elderly': def('Elderly', () => import('@mui/icons-material/Elderly')),
  'volunteering': def('Volunteering', () => import('@mui/icons-material/VolunteerActivism')),
  'pets': def('Pets', () => import('@mui/icons-material/Pets')),

  // --- Places & Travel ---
  'home': def('Home', () => import('@mui/icons-material/Home')),
  'hotel': def('Hotel', () => import('@mui/icons-material/Hotel')),
  'location': def('Location', () => import('@mui/icons-material/LocationOn')),
  'explore': def('Explore', () => import('@mui/icons-material/Explore')),
  'commute': def('Commute', () => import('@mui/icons-material/Commute')),
  'store': def('Store', () => import('@mui/icons-material/Storefront')),
  'nightlife': def('Nightlife', () => import('@mui/icons-material/Nightlife')),

  // --- Self-care ---
  'bathtub': def('Bath', () => import('@mui/icons-material/Bathtub')),
  'weekend': def('Relax', () => import('@mui/icons-material/Weekend')),

  // --- Creative & Misc ---
  'note': def('Note', () => import('@mui/icons-material/Note')),
  'writing': def('Writing', () => import('@mui/icons-material/Create')),
  'palette': def('Palette', () => import('@mui/icons-material/Palette')),
  'colorlens': def('Color', () => import('@mui/icons-material/ColorLens')),
  'camera': def('Camera', () => import('@mui/icons-material/CameraAlt')),
  'photo': def('Photo', () => import('@mui/icons-material/Image')),
  'puzzle': def('Puzzle', () => import('@mui/icons-material/Extension')),
  'science': def('Science', () => import('@mui/icons-material/Science')),

  // --- Finance ---
  'money': def('Money', () => import('@mui/icons-material/AttachMoney')),
  'shopping': def('Shopping', () => import('@mui/icons-material/ShoppingCart')),

  // --- Alerts ---
  'priority': def('Priority', () => import('@mui/icons-material/PriorityHigh')),

  // --- Balance ---
  'balance': def('Balance', () => import('@mui/icons-material/Balance')),

  // --- Default fallback ---
  'default': def('Default', () => import('@mui/icons-material/Note')),
};

// Get icon entry by key
export const getIconEntry = (key) => {
  if (!key) return iconRegistry['default'];
  return iconRegistry[key.toLowerCase()] || iconRegistry['default'];
};

// Get all icon keys (excluding 'default')
export const getIconKeys = () => {
  return Object.keys(iconRegistry).filter(key => key !== 'default');
};

// Get all icons as array of { key, label } for selection UI
export const getIconOptions = () => {
  return Object.entries(iconRegistry)
    .filter(([key]) => key !== 'default')
    .map(([key, { label }]) => ({ key, label }));
};